import styled from '@emotion/styled';
import { Button as ButtonComponent } from '@mui/material';
import { IconButton as IconButtonComponent } from '@mui/material';
import { Colors } from 'styles/variables/colors';
import { TextStyle } from 'styles/variables/mixins';
import { Variables } from 'styles/variables/variables';

const { orange, darkGray } = Colors;
const { assistant } = Variables;

export const Button = styled(ButtonComponent)`
    ${TextStyle({ fontSize: '14px', fontWeight: '500' })}
    margin-bottom: 28px;
    border: 2px solid ${orange};
    text-transform: capitalize;
    padding: 12px 18px;
    height: auto;
    line-height: 17px;

    :hover {
        border: 2px solid ${orange};
        background-color: #f8f8f8;
    }

    :active {
        box-shadow: none;
    }

    :focus {
        box-shadow: 0 0 0 0.2rem rgba(243, 167, 18, 0.5);
    }

    @media screen and (max-width: 500px) {
        order: -1;
        margin-bottom: 10px;
    }
`;

export const IconButton = styled(IconButtonComponent)`
    font-family: ${assistant};
    font-size: 15px;
    color: ${darkGray};
    margin-bottom: 28px;
    @media screen and (max-width: 500px) {
        margin-bottom: 10px;
    }
`;
